module.exports = __webpack_public_path__ + "static/media/download.20cbc780.svg";